import { iconButtonClasses } from '@mui/material/IconButton';

const COLORS = ['primary', 'secondary', 'info', 'success', 'warning', 'error'];

export function iconButton(theme) {
  const lightMode = theme.palette.mode === 'light';

  const rootStyles = ownerState => {
    const outlinedVariant = ownerState.variant === 'outlined';
    const containedVariant = ownerState.variant === 'contained';

    const outlinedStyle = {
      backgroundColor: theme.palette.background.primaryWhite1,
      border: `1px solid ${theme.palette.border.primaryBlack3}`,
      borderRadius: '6px',
      '&:hover': {
        backgroundColor: theme.palette.background.primaryGrey1,
      },
    };

    const containedStyle = {
      color: lightMode
        ? theme.palette.content.primaryWhite
        : theme.palette.grey[800],
      backgroundColor: lightMode
        ? theme.palette.background.primaryBlack1
        : theme.palette.common.white,
      '&:hover': {
        backgroundColor: lightMode
          ? theme.palette.background.primaryAccent1
          : theme.palette.grey[400],
      },
      '& .MuiButton-startIcon, & .MuiButton-endIcon': {
        color: lightMode ? 'inherit' : theme.palette.grey[800],
      },
    };

    const defaultStyle = {
      color: 'currentColor',
      ...(outlinedVariant && outlinedStyle),
      ...(containedVariant && containedStyle),
    };

    const rippleStyles = {
      [`& .${iconButtonClasses.touch}`]: {
        backgroundColor: theme.palette.background.primaryGrey1,
        ...(outlinedVariant && { borderRadius: '6px' }),
      },
    };

    const colorStyle = COLORS.map(color => ({
      // You can customize styles for specific colors here if needed
    }));

    const disabledState = {
      [`&.${iconButtonClasses.disabled}`]: {
        // Styles for the disabled state
        backgroundColor: 'transparent',
      },
    };

    const typography = {
      // Typography styles can be customized here
    };

    const size = {
      // Size-related styles can be customized here
    };

    return [
      { alignItems: 'center' },
      defaultStyle,
      ...colorStyle,
      disabledState,
      size,
      typography,
      rippleStyles,
    ];
  };

  return {
    MuiIconButton: {
      styleOverrides: {
        root: ({ ownerState }) => rootStyles(ownerState),
      },
    },
  };
}
